import { useRef, useState } from 'react';
import { PrimaryButton } from '@fluentui/react';
import useAxios from "axios-hooks";

const LogoUploader = ({ cdnPath, setFieldValue, color, type = 'desktop' }) => {
    const hiddenFileInputRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState('');

    const fields = {
        retina: type === 'desktop' ? `retinaLogo${color}` : `retinaMobileAltLogo${color}`,
        standard: type === 'desktop' ? `standardLogo${color}` : `standardMobileAltLogo${color}`,
        pxWidth: type === 'desktop' ? 'pxWidthStandardLogoDesktopTablet' : 'pxWidthStandardMobileLogoMobile',
    };

    const [{ loading }, postImage] = useAxios(
        {
            url: '/resources/content/admin/upload-image',
            method: "post",
            headers: { 'content-type': 'multipart/form-data' }
        },
        { manual: true }
    );

    const uploadImage = async (file) => {
        const data = new FormData();
        data.append("Image", file);
        data.append("Path", cdnPath);
        await postImage({ data });
    };

    function handleClick() {
        hiddenFileInputRef.current?.click();
    }

    function handleChange(e) {
        if (!e.target.files) return;
        const file = e.target.files[0];

        if (file.type !== 'image/png') return setErrorMessage('Please upload a .png file type');
        if (file.size > 200000) return setErrorMessage('File is too large');

        const img = new Image();
        const objectUrl = window.URL.createObjectURL(file);

        img.onload = async () => {
            setErrorMessage('');

            if (img.height < 96) {
                setErrorMessage(`Image height must be at least 96px`);
                window.URL.revokeObjectURL(objectUrl);
                return;
            }

            if (img.width > 640 || img.height > 132) {
                setErrorMessage(`Image width may not exceed 640px and height may not exceed 132px`);
                window.URL.revokeObjectURL(objectUrl);
                return;
            }

            const originalName = file.name.replace(/\.png$/i, '');
            const fileNameWith2x = `${originalName}@2x.png`;
            const fullSizeFile = new File([file], fileNameWith2x, { type: file.type });

            await uploadImage(fullSizeFile);

            setFieldValue(fields.retina, `/${cdnPath}/${fileNameWith2x}`);
            setFieldValue(fields.standard, `/${cdnPath}/${originalName}.png`);
            setFieldValue(fields.pxWidth, img.width);

            const canvas = document.createElement('canvas');
            canvas.width = img.width / 2;
            canvas.height = img.height / 2;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            canvas.toBlob(async (blob) => {
                if (blob) {
                    const resizedFile = new File([blob], `${originalName}.png`, { type: 'image/png' });
                    await uploadImage(resizedFile);
                }
            }, 'image/png');

            window.URL.revokeObjectURL(objectUrl);
        };

        img.src = objectUrl;
    }

    return (
        <div className="mt20">
            {errorMessage && (
                <div className="mb10" style={{ color: 'red' }}>
                    {errorMessage}
                </div>
            )}
            <div className="flex justify-between">
                <PrimaryButton onClick={handleClick} text="Upload Logo" />
            </div>
            <input
                ref={hiddenFileInputRef}
                type="file"
                style={{ display: 'none' }}
                onChange={handleChange}
            />
        </div>
    );
};

export default LogoUploader;
